/**
 * Shared styling constants for insight dashboard chart tooltips and legends.
 * All chart widgets should reference these to maintain visual consistency.
 */

/** Pixel margin above the chart plot area to prevent data from touching the top edge. */
export const CHART_MARGIN_TOP = 20;

export const chartStyles = {
  swatch: "tw:h-2.5 tw:w-2.5 tw:shrink-0 tw:rounded-[2px]",
  tooltipContainer: "tw:bg-background tw:border tw:rounded-lg tw:p-2 tw:shadow-md tw:text-xs",
  tooltipRow: "tw:flex tw:items-center tw:gap-2",
  legendContainer: "tw:flex tw:flex-wrap tw:items-center tw:justify-center tw:gap-4 tw:pt-3",
  legendItem: "tw:flex tw:items-center tw:gap-1.5 tw:text-xs",
} as const;
